import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import FilterCollection from 'components/organisms/FilterCollection';

const ManagerFilter = ({ getParam, params }) => {
  const { t } = useTranslation();
  const { contactMenus } = useSelector(({ common }) => ({
    contactMenus: common.contactMenus,
  }));

  /**
   * 영업 담당자 필터 선택
   * @param {string} name
   * @param {*} value
   */
  const handleFilterChange = (newParams) => {
    getParam({
      ...newParams,
    });
  };
  return (
    <FilterCollection
      label={t('담당자')}
      value={params.contact}
      name="contact"
      type="select"
      params={params}
      list={contactMenus}
      labelKey="CONTACT_NAME"
      valueKey="CONTACT_NO"
      callBack={handleFilterChange}
    />
  );
};

export default ManagerFilter;

// <MbSelectbox
//     label={typeof label === 'undefined' ? t('담당자') : label}
//     value={value}
//     itemindex={index}
//     name={name}
//     optionData={contactMenus}
//     optionLabelKey=""
//     optionValueKey=""
//     handleOnchange={handleFilterChange}
//     icon={false}
//     style={style}
//   />
